import React from 'react';
import {Box, Button, Checkbox, FormControlLabel} from '@mui/material';
import {LazyQueryExecFunction} from '@apollo/client';
import ActionModal from '../../components/ContactActions/ActionModal';
import AutoField, {
  ActionType,
  CheckboxGroupField,
} from '../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';
import {enumToLabel} from '../../utils/typescriptUtils';
import {
  SearchReportPacks,
  SearchReportPacksVariables,
} from '../../schema-types/SearchReportPacks';
import {
  ReportPackDashboardValues,
  reportPackStatusKeys,
} from './ReportPackDashboardTypes';
import {UPDATES} from '../../shared/UPDATES';

export const statusesField: CheckboxGroupField = {
  type: ActionType.checkboxGroup,
  options: [],
  id: 'statuses',
  label: 'Please select the status(es)',
};

export default function ReportPackDashboardStatusFiltersModal({
  isOpen,
  close,
  fetch,
}: {
  isOpen: boolean;
  close: () => void;
  fetch: LazyQueryExecFunction<SearchReportPacks, SearchReportPacksVariables>;
}) {
  const {values, setFieldValue} = useAutoForm<ReportPackDashboardValues>();

  const allStatusValues = reportPackStatusKeys;
  const isAllSelected = values.statuses.length === allStatusValues.length;
  const isIndeterminate =
    values.statuses.length > 0 && values.statuses.length < allStatusValues.length;

  const handleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      setFieldValue(UPDATES._2008, 'statuses', []);
    } else {
      // Select all
      setFieldValue(UPDATES._2009, 'statuses', allStatusValues);
    }
  };

  return (
    <ActionModal title="Filter by Status" isOpen={isOpen} close={close} autoHeight wide>
      <Box padding={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isAllSelected}
              indeterminate={isIndeterminate}
              onChange={handleSelectAll}
            />
          }
          label="Select All"
        />
      </Box>
      <Box overflow="scroll" padding={1} height="500px">
        <AutoField
          field={{
            ...statusesField,
            options: reportPackStatusKeys.map((key) => ({
              label: enumToLabel(key),
              value: key,
            })),
          }}
        />
      </Box>
      <Box display="flex" justifyContent="end">
        <Button
          color="secondary"
          variant="outlined"
          onClick={async () => {
            setFieldValue(UPDATES._2010, 'statuses', []);
            await fetch({
              variables: {
                adviserIds: values.adviserIds,
                contactNameIncludes: values.search,
                statuses: [],
              },
            });
            close();
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          sx={{marginLeft: 2}}
          onClick={async () => {
            await fetch({
              variables: {
                adviserIds: values.adviserIds,
                contactNameIncludes: values.search,
                statuses: values.statuses,
              },
            });
            close();
          }}
        >
          Filter
        </Button>
      </Box>
    </ActionModal>
  );
}
